import { Container, Title, Text, Stack, Card, Grid, ThemeIcon } from '@mantine/core'
import { IconCar, IconUsers, IconAward, IconClock } from '@tabler/icons-react'

export function AboutPage() {
  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <Title order={1} ta="center" mb="md">
          О компании Auto Expert
        </Title>
        
        <Text size="lg" ta="center" c="dimmed" maw={800} mx="auto">
          Мы — команда профессионалов с многолетним опытом работы в сфере автосервиса. 
          Наша миссия — обеспечить качественный ремонт и обслуживание вашего автомобиля.
        </Text>

        <Grid mt="xl">
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Card shadow="sm" padding="lg" radius="md" withBorder>
              <ThemeIcon size="xl" radius="md" variant="gradient" gradient={{ from: 'blue', to: 'cyan' }} mb="md">
                <IconCar size="2rem" />
              </ThemeIcon>
              <Title order={3} mb="sm">Наш опыт</Title>
              <Text c="dimmed">
                Более 15 лет мы работаем с автомобилями различных марок и моделей. 
                Наши специалисты постоянно повышают квалификацию и изучают новые технологии.
              </Text>
            </Card>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <Card shadow="sm" padding="lg" radius="md" withBorder>
              <ThemeIcon size="xl" radius="md" variant="gradient" gradient={{ from: 'green', to: 'teal' }} mb="md">
                <IconUsers size="2rem" />
              </ThemeIcon>
              <Title order={3} mb="sm">Наша команда</Title>
              <Text c="dimmed">
                В нашей команде работают только сертифицированные мастера с большим опытом. 
                Каждый специалист проходит регулярное обучение и аттестацию.
              </Text>
            </Card>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <Card shadow="sm" padding="lg" radius="md" withBorder>
              <ThemeIcon size="xl" radius="md" variant="gradient" gradient={{ from: 'orange', to: 'red' }} mb="md">
                <IconAward size="2rem" />
              </ThemeIcon>
              <Title order={3} mb="sm">Наши достижения</Title>
              <Text c="dimmed">
                Мы гордимся тем, что более 95% наших клиентов рекомендуют нас друзьям. 
                Это лучшая оценка качества нашей работы.
              </Text>
            </Card>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <Card shadow="sm" padding="lg" radius="md" withBorder>
              <ThemeIcon size="xl" radius="md" variant="gradient" gradient={{ from: 'violet', to: 'grape' }} mb="md">
                <IconClock size="2rem" />
              </ThemeIcon>
              <Title order={3} mb="sm">Наши принципы</Title>
              <Text c="dimmed">
                Честность, качество и индивидуальный подход к каждому клиенту — 
                это основа нашей работы уже много лет.
              </Text>
            </Card>
          </Grid.Col>
        </Grid>
      </Stack>
    </Container>
  )
}